// Wire-protocol constants BOTH ends must agree on, shared so they cannot drift.
//
// A header name is a contract: the client sends it, the server matches it, and a
// typo in either place fails silently — the request simply behaves as though the
// preference was never expressed. That is precisely the kind of disagreement
// worth spending a shared module on.

/** RFC 7240 return preference. */
export const RETURN_PREFERENCE_HEADER = "Prefer";

/**
 * "I will not read the record you would send back, so do not build it."
 *
 * Every write route rebuilds the full record to return it, and the Neon driver
 * speaks HTTP — so each query inside that rebuild is its own round trip. A
 * booking detail is eight of them. Not one call site in the web app reads a
 * write's response: they all `await` and discard, taking freshness from a
 * separate revalidating GET. Sending this turned a two-field booking save from
 * ~900ms to ~220ms, measured against the dev branch on 2026-08-15.
 */
export const MINIMAL_RETURN = "return=minimal";
